import type { ReactNode } from "react";
import type { TFunction } from "i18next";
import { useTranslation } from "react-i18next";
import { TableElem } from "../ui/customs/tableElem";

type Render = (t: TFunction<"boExpeditions">) => string;

// CODE POURRI A VIRER QUAND ON AURA REFAIT LA PAGE DES EXPÉS CLIENT
// GÉNÉRÉ PAR AI, ÇA MARCHE MAIS C'EST NAZE
// DANS expeditionColumns.tsx c mieux

/**
 * Texte traduit utilisable hors d'un composant (en-têtes/cellules de colonnes construites par
 * des fonctions non-hooks) : la traduction est faite au rendu.
 */
export const PendingShipmentsText = ({ render }: { render: Render }) => {
  const { t } = useTranslation("boExpeditions");
  return <>{render(t)}</>;
};

/** `TableElem` dont le libellé est traduit au rendu. */
export const PendingShipmentsTableElem = ({
  name,
  children,
}: {
  name: Render;
  children: ReactNode;
}) => {
  const { t } = useTranslation("boExpeditions");
  return <TableElem name={name(t)}>{children}</TableElem>;
};
